import AbstractVertical from './AbstractVertical'

export default class Monthly extends AbstractVertical {

  readonly name: string = 'monthly'
  readonly title: string = 'Monthly'
  readonly color: string = '#526172'
  readonly sortWeight: number = 20

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'editInventory',
    'showOnUniversalInventoryCalendar',
    'spotRates',
    'limitedByWeekday',
  ]

}
